export default __webpack_public_path__ + "static/media/wired-upload.5b8c9758.jpg";